import 'core-js'
import Vue from 'vue'
import App from './App.vue'
import 'normalize.css'
import '@/assets/css/main.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';
import VueYoutube from 'vue-youtube'

var VueScrollTo = require('vue-scrollto');
 
Vue.config.productionTip = false

Vue.use(VueYoutube)
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

new Vue({
  render: h => h(App),
}).$mount('#app')

AOS.init({
  duration: 800,
  anchorPlacement: 'top-bottom',
  duration: 600,
  once: true
});
